import { Edit } from "react-admin";
import { JobApplicationStatusForm } from "./index";
import { EditToolbar } from "@components/EditToolbar";

export const JobApplicationStatusEdit = () => (
  <Edit mutationMode="pessimistic">
    <JobApplicationStatusForm toolbar={<EditToolbar showDeleteButton={false} />} />
  </Edit>
);
